<template>
  <div class="home">
    <div id="home-content">
      <div id="home-content-hero">
        <img id="host-animoji" alt="Hosts" src="../assets/hosts-animoji.png" />
        <p class="title">TrioTalk</p>
        <p class="subtitle">A tech podcast hosted by a trio of indie developers:<br>
          <a href="https://twitter.com/kevinzhow">Kevin</a>,
          <a href="https://twitter.com/roczhang9673">Roc</a>, and
          <a href="https://twitter.com/JustZht">Justin</a>.</p>
<!--        <p class="notice">STAY TUNED FOR OUR FIRST EPISODE</p>-->
      </div>
    </div>
    <img id="parental-advisory-label" alt="Hosts" src="../assets/parental-advisory-label.png" />
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from "@/components/HelloWorld.vue";

export default {
  name: "Home",
  components: {
  }
};
</script>

<style>
  /*html {*/
  /*  font-size: 16px;*/
  /*}*/
  /*@media screen and (min-width: 320px) {*/
  /*  html {*/
  /*    font-size: calc(16px + 6 * ((100vw - 320px) / 680));*/
  /*  }*/
  /*}*/
  /*@media screen and (min-width: 1000px) {*/
  /*  html {*/
  /*    font-size: 22px;*/
  /*  }*/
  /*}*/
  p, h1, h2, h3, h4, h5, h6
  {
    color: white;
  }
  a {
    color: #ffedc4;
    text-decoration-style: solid;
  }
  .title
  {
    width: 90%;
    font-size: 12vmin;
    margin-top: 2vmin;
    margin-bottom: 0;
    text-align: center;
  }
  .subtitle
  {
    width: 70%;
    margin-top: 2vmin;
    font-size: 3.2vmin;
    font-style: italic;
    text-align: center;
  }
  .notice
  {
    font-size: 1.5vmin;
    font-weight: bold;
  }
  #home-content-hero
  {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100vw;
    height: 150vw; /* height:width ratio = 9/16 = .5625  */
    max-height: 100vh;
    max-width: 66.67vh; /* 16/9 = 1.778 */
    margin: auto;
    position: absolute;
    top:0;bottom:0; /* vertical center */
    left:0;right:0; /* horizontal center */
  }
  #home-content
  {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
  #host-animoji
  {
    width: 100%;
    height: 50%;
    object-fit: contain;
  }
  #parental-advisory-label
  {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    display: block;
    max-width:12%;
    max-height:8%;
    width: auto;
    height: auto;
  }
  .home
  {
    position: fixed;
    width: 100%;
    height: 100%;
  }
</style>